/**
 * Scales images to be visually proportionate based on aspect ratio. An implementation of https://danpaquette.net/read/automatically-resizing-a-list-of-icons-or-logos-so-theyre-visually-proportional/
 * @param {string} selector - An element selector for a set of elements to normalise
 * @param {int} widthBase - The width a square image would be scaled to
 * @param {int} scaleFactor - A balancing factor between scaling for height and width. The default is generally visually balanced.
 * @param {Element} parentEl - A parent element to search for the selector. Defaults to document.
 * Example usage, scaling home banner images to an average of 40px width:
 * window.onload = function() { 
 *     proportionalImageNormalisation(".banners-home .banner-inner-image", 40);
 * };
 */ 

function adjustImageWidth(element, widthBase, scaleFactor=0.525) {
    var imageRatio;
    if (element instanceof HTMLImageElement) {
        imageRatio = element.naturalWidth / element.naturalHeight;
        element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + 'px';
    } else if (element instanceof HTMLPictureElement) {
        let imageElement = element.querySelector('img');
        imageRatio = imageElement.naturalWidth / imageElement.naturalHeight;
        element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + 'px';
    } else {
        imageRatio = element.clientWidth / element.clientHeight;
        element.style.width = (Math.pow(imageRatio, scaleFactor) * widthBase) + 'px';
    }
}
export function ProportionalImageNormalisation(selector, widthBase=50, scaleFactor=0.525, parentEl=document){  
    var elements = parentEl.querySelectorAll(selector, widthBase, scaleFactor);
   
    elements.forEach((element) => adjustImageWidth(element, widthBase, scaleFactor));
}